import { createContext, useContext } from "react";

import { ProductPlanI18nFormModelContext } from "../../_shared/context/context";

import type { ProductPlanI18nFormModelContextType } from "../../_shared/context/context";

export type ProductExistingPlanI18nFormModelContextType = {
	onUpdate: () => void;
} & ProductPlanI18nFormModelContextType;

export const ProductExistingPlanI18nFormModelContext =
	createContext<ProductExistingPlanI18nFormModelContextType | null>(null);

export const ProductExistingPlanI18nFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductExistingPlanI18nFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductExistingPlanI18nFormModelContext.Provider value={value}>
			<ProductPlanI18nFormModelContext.Provider value={value}>
				{children}
			</ProductPlanI18nFormModelContext.Provider>
		</ProductExistingPlanI18nFormModelContext.Provider>
	);
};

export const useProductExistingPlanI18nFormModelContext = () => {
	const context = useContext(ProductExistingPlanI18nFormModelContext);

	if (!context) {
		throw new Error(
			"useProductExistingPlanI18nFormModelContext must be used within a ProductExistingPlanI18nFormModelContextProvider",
		);
	}

	return {
		onUpdate: context.onUpdate,
	};
};
